import { Responsive } from 'connex-cds';
import { useTicketContext } from '../../../TicketContext';
import React, { useMemo } from 'react';
import LoadingPointDesktop from './LoadingPointDesktop';
import LoadingPointMobile from './LoadingPointMobile';

export const LoadingPoint = () => {
  const { ticket } = useTicketContext();

  const plantAddress = useMemo(
    () => {
      const address = ticket?.origin?.address;
      const stateZip = [address?.countrySubDivision, address?.postalCode].filter(Boolean).join(' ');
      return [address?.address1, address?.address2, address?.city, stateZip].filter(Boolean).join(', ');
    }, [ticket?.origin?.address]
  );

  const datetimeLoadingStarted = useMemo(() => {
    const event = ticket?.scheduledEvents?.LOADING_STARTED;
    if (event?.eventDateTime) {
      return event.eventDateTime;
    }
    if (typeof event === 'string') {
      return event;
    }

    return ticket?.customData?.schedule?.pickupTimeFrom ?? null;
  }, [ticket?.scheduledEvents, ticket?.customData?.schedule?.pickupTimeFrom]);

  return (
    <Responsive>
      <LoadingPointMobile ticket={ticket} plantAddress={plantAddress} loadingStarted={datetimeLoadingStarted} />
      <LoadingPointDesktop ticket={ticket} plantAddress={plantAddress} loadingStarted={datetimeLoadingStarted} />
    </Responsive>
  );
};
